// components/About.js
import React from 'react';
import './About.css'; // Importing the CSS file


const About = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>Learn more about our company and values.</p>
    </div>
  );
};

export default About;
